// import { MessageBox } from 'element-ui'
import {
  getToken,
  removeToken,
  removeInfo
  // getRefreshToken
} from "@/utils/auth";

const state = {
  token: getToken(),
  isMobile: false
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_IS_MOBILE: (state, data) => {
    state.isMobile = data;
  }
};

const actions = {
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      removeToken();
      removeInfo();
      resolve();
    });
  },
  setIsMobile({ commit }, data) {
    commit("SET_IS_MOBILE", data);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
